<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="add"
          >新增短信模板</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入短信标题"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateType"
          label="模板类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateTitile"
          label="模板标题"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateContent"
          label="短信内容"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="添加时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="添加人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="ruleName"
          label="状态"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              class="mr10"
              type="text"
              @click="operation(scope.row, 'no')"
              :disabled="scope.row.enabledState === 'no'"
              >停用</el-button
            >/<el-button
              size="small"
              type="text"
              @click="operation(scope.row, 'yes')"
              :disabled="scope.row.enabledState === 'yes'"
              >启用</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加模板类型"
      :close-on-click-modal="false"
      @close="dialogTemplate = false"
      :visible.sync="dialogTemplate"
    >
      <el-form
        label-width="120px"
        :model="ruleFormTemplate"
        :rules="rulesTemplate"
        ref="ruleFormTemplate"
      >
        <el-form-item label="添加模板类型" prop="templateType">
          <el-input
            maxlength="20"
            placeholder="请输入类型名称(限制20个字符）"
            size="small"
            clearable
            v-model="ruleFormTemplate.templateType"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="submitTemplate('ruleFormTemplate')"
          size="small"
          type="primary"
          >确认</el-button
        >
        <el-button @click="dialogTemplate = false" size="small">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="dialogVisible"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="模板类型" prop="templateType">
          <el-select
            clearable
            v-model="ruleForm.templateType"
            placeholder="请选择模板类型"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              v-for="item in templatesTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-button size="small" type="text" @click="dialogTemplate = true"
            >添加模板类型</el-button
          >
        </el-form-item>
        <el-form-item label="模板标题" prop="templateTitile">
          <el-input
            maxlength="20"
            clearable
            placeholder="请输入短信标题(限制20个字符)"
            size="small"
            v-model="ruleForm.templateTitile"
          ></el-input>
        </el-form-item>
        <el-form-item label="短信内容" prop="templateContent">
          <el-input
            maxlength="70"
            clearable
            placeholder="请输入模板内容，建议不要超过70个字符，否则将会导致短信多条发送"
            size="small"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.templateContent"
          ></el-input>
          <!-- <div class="form-item-tip">
            店长特批，需要备注店长信息
          </div> -->
        </el-form-item>
        <el-form-item label="状态" prop="enabledState">
          <el-switch
            v-model="ruleForm.enabledState"
            active-color="#13ce66"
            active-value="yes"
            inactive-value="no"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      templatesTypeList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      dialogVisible: false,
      dialogTemplate: false,
      ruleForm: {
        templateType: "",
        templateTitile: "",
        templateContent: "",
        status: false
      },
      rules: {
        templateType: {
          required: true,
          message: "请选择模板类型",
          trigger: "change"
        },
        templateTitile: {
          required: true,
          message: "请输入短信标题",
          trigger: "change"
        },
        templateContent: {
          required: true,
          message: "请输入模板内容",
          trigger: "change"
        },
        status: {
          required: true
        }
      },
      ruleFormTemplate: {
        templateType: ""
      },
      rulesTemplate: {
        templateType: {
          required: true,
          message: "请输入类型名称",
          trigger: "change"
        }
      },
      title: "",
      length: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "querySmsTemplatesList",
        params
      );
      const { records, total } = result;

      this.list = records;
      this.total = total;
    },
    queryTemplatesTypeList() {
      return this.$store.dispatch("queryTemplatesTypeList").then(res => {
        this.templatesTypeList = res.result;
      });

      // this.length = result.length;
      // const { records, total } = result;
      // this.list = records;
      // this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    operation(row, type) {
      const params = JSON.parse(JSON.stringify(row));
      params.enabledState = type;
      this.$store.dispatch("editSmsTemplates", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    add() {
      this.dialogVisible = true;
      this.title = "新增短信模板";
      this.queryTemplatesTypeList();
    },
    edit(row) {
      this.dialogVisible = true;
      this.title = "编辑短信模板";
      this.queryTemplatesTypeList();
      this.$store
        .dispatch("detailsSmsTemplates", { smsTemplateId: row.smsTemplateId })
        .then(res => {
          if (res.code === "0") {
            for (let key in res.result) {
              this.ruleForm[key] = res.result[key];
            }
          }
        });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },
    resetRuleFormTemplate() {
      this.$refs.ruleFormTemplate.resetFields();
    },
    async submitReject(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        // Object.assign(params, this.row);

        this.$store
          .dispatch(
            this.title === "新增短信模板"
              ? "saveSmsTemplates"
              : "editSmsTemplates",
            params
          )
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              setTimeout(() => {
                this.resetRuleForm();
                this.resetRuleFormTemplate();
              }, 0);
              this.dialogVisible = false;
              this.queryList();
            }
          });
      } else {
        return false;
      }
    },
    async submitTemplate(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        this.queryTemplatesTypeList().then(() => {
          let set = new Set([
            ...this.templatesTypeList,
            this.ruleFormTemplate.templateType
          ]);
          this.templatesTypeList = Array.from(set);
        });

        // let flag = false;
        // this.templatesTypeList.forEach(v => {
        //   if (v === this.ruleFormTemplate.templateType) {
        //     flag = true;
        //   }
        // });

        // if (!flag) {
        //   if (this.length === this.ruleFormTemplate.length) {
        //     this.templatesTypeList.push(this.ruleFormTemplate.templateType);
        //   } else {
        //     this.templatesTypeList.remove(this.ruleFormTemplate.length);
        //     this.templatesTypeList.push(this.ruleFormTemplate.templateType);
        //   }
        // }

        this.dialogTemplate = false;
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
